<template>
  <div class="points-log">
    <div v-if="records.length">
      <div class="mui-card" v-for="record in records" :key="record.id">
        <div class="mui-card-header">
          <span>{{ getActionTitle(record) }}</span>
          <span :class="['change-amount', record.change_amount >= 0 ? 'increase' : 'decrease']">
            {{ record.change_amount >= 0 ? '+' : '' }}{{ record.change_amount }}
          </span>
        </div>
        <div class="mui-card-content">
          <div class="mui-card-content-inner">
            <p>时间：{{ formatDate(record.create_time) }}</p>
            <p>说明：{{ record.action_desc || '积分变动' }}</p>
            <p>变动前：{{ record.before_points }}</p>
            <p>变动后：{{ record.after_points }}</p>
            <p v-if="record.related_order_id">关联订单：{{ record.related_order_id }}</p>
            <p v-if="record.operator_username">操作人：{{ record.operator_username }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty-state">暂无积分记录</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      records: []
    }
  },
  created () {
    this.fetchPointsLogs()
  },
  methods: {
    fetchPointsLogs () {
      this.$indicator.open({ text: '加载中' })
      this.$http.get('/user/points/logs').then(res => {
        if (res.data.code === 1) {
          this.records = res.data.data || []
        } else if (res.data.code === 2) {
          this.$router.push({ name: 'login' })
        } else {
          this.$toast(res.data.msg || '加载失败')
        }
      }).catch(() => {
        this.$toast('加载失败')
      }).finally(() => {
        this.$indicator.close()
      })
    },
    formatDate (value) {
      if (!value) return ''
      return new Date(value).toLocaleString('zh-CN')
    },
    getActionTitle (record) {
      const titleMap = {
        admin_update: '管理员修改积分',
        batch_import: '批量导入积分',
        order_create: '下单扣减积分',
        order_cancel: '取消订单返还积分'
      }
      return titleMap[record.action_type] || '积分变动'
    }
  }
}
</script>

<style lang="scss" scoped>
.points-log {
  padding: 10px;
}

.mui-card-header {
  font-size: 14px;
  color: #666;
}

.change-amount {
  font-weight: bold;
}

.increase {
  color: #2e7d32;
}

.decrease {
  color: #d32f2f;
}

.mui-card-content-inner p {
  margin: 6px 0;
  color: #555;
}

.empty-state {
  margin-top: 40px;
  text-align: center;
  color: #999;
}
</style>
